import { Component, OnInit } from '@angular/core';
import { IReservationChangeNofshon } from 'app/admin/interface/ireservationChangeNofesh.interface';
import { NofshonNirshamimChangeNofesh } from 'app/admin/interface/nofshon-nirhsamim-change-nofesh';
import { IChangeReservation } from 'app/admin/interface/changeReservation';
import { IHerkevHazmana } from 'app/nofshonim-chul/model/herkev-hazmana';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminService } from 'app/admin/admin.service';
import { Router } from '@angular/router';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { MatDialog } from '@angular/material';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { NofshonimService } from 'app/nofshonim-chul/nofshonim.service';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';



interface IKeyValue
{
  key: number;
  value: string;
  
}
interface IKeyValues
{
  key: number;
  value: string;
  secondValue: string;
}

@Component({
  selector: 'app-find-oved',
  templateUrl: './find-oved.component.html',
  styleUrls: ['./find-oved.component.css']
})
export class FindOvedComponent implements OnInit {

  choosedTitleForChange: number;
  showAvailableRooms: boolean = false;
  availableRoomsStandard: number;
  availableRoomsHamtana: number;
  is_updated:boolean = false;
  is_Oved_Exists:boolean=false;
  ms_zehut_valid:boolean = true;
  is_oved_searched:boolean = false;
  isOvedMazminFound:boolean = false;
  nofshonimReservations: IReservationChangeNofshon[] = [];
  selectedReservation : IReservationChangeNofshon;
  selectedReservationForChange:NofshonNirshamimChangeNofesh ;
  changeReservationNofshon : IChangeReservation;
  nofesh_title : string  = "";
  maxAmitim: number;
  maxNilvim: number;
  quotationSubmitted: boolean = false;
  isValidHerkevHazmana: boolean = true;
  nofesh_price: number;
  ms_chadarim: number;
  return_message: string;
  quotation_success: boolean = true;
  is_hamtana: boolean;
  nofeshId: number;
  currentNumberOfRooms: number;
  CurrentHerkevHazmana: IHerkevHazmana = {
    nofesh_id: 0,
    ms_amit: 0,
    ms_nilve: 0,
    ms_yeladim: 0,
    ms_tinokot: 0
};
  isHamtanaForNewNofesh: boolean;

  get amitim() { return this.herkevHazmana.get("ms_amit"); };
  get nilvim() { return this.herkevHazmana.get("ms_nilve"); };
  get yeladim() { return this.herkevHazmana.get("ms_yeladim"); };
  get tinokot() { return this.herkevHazmana.get("ms_tinokot"); }
  
  get ms_zehut_mazmin_error() { return this.nofesh.get('ms_zehut_mazmin'); }

  constructor(private fb: FormBuilder,
              private _adminService: AdminService,
              private router: Router,
              private userMessages: UserMessagesService,
              private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private confirmService : ConfirmService,
              private _nofeshService :NofeshService,
              private _userMessagesService: UserMessagesService,
              private _nofshonimService: NofshonimService) { }

  ngOnInit() {
    
  }


  herkevHazmana = this.fb.group({
    ms_amit: [ 1, Validators.compose([Validators.required, Validators.min(1), Validators.max(this.maxAmitim)]) ],
    ms_nilve: [ 0, Validators.compose([Validators.required, Validators.max(this.maxNilvim)]) ],
    ms_yeladim: [ 0, Validators.compose([Validators.required]) ],
    ms_tinokot: [ 0, Validators.compose([Validators.required]) ]

    
})

  nofesh = this.fb.group({
    //main mazmin
    nofeshTitle:[0],
    ms_zehut_mazmin:['',Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    nofeshTitleForChange:[0],
     tr_leida:[''],
     shem_prati:[''],
     shem_mishpacha:[''],
     ms_zehut:[''],
     phone:[''],
     nofesh_title:[''],
     nofesh_from:[''],
     nofesh_to:[''],
     is_hamtana:[''],
     ofen_tashlum: ["", Validators.required]
  })
  allNofshonimTitles :IKeyValue[] = [
    {key: 0, value: "בחר"}
  ]
  
  nofeshTitles: IKeyValue[] = [
    { key: 0, value: "בחר" }
  ];

  displayNofesh()
  {

    // this._adminService.GetCurrentNofeshMisparChadarim(this.nofesh.value.ms_zehut_mazmin,this.nofesh.value.nofeshTitle).subscribe((result) =>{
    //   this.currentNumberOfRooms = result.data;
      
    // })
debugger;
    this._userMessagesService.clearAll();
    this.selectedReservation = this.nofshonimReservations.find(reservation => reservation.nirshamim[0].id_nofesh == this.nofesh.value.nofeshTitle);    
    this.getAllNofshonim();
    //this.getCurrentHerkevHazmana();
    
  }
  // getCurrentNofeshMisparChadarim()
  // {
    
  //     this._adminService.GetCurrentNofeshMisparChadarim(this.nofesh.value.ms_zehut_mazmin,this.nofesh.value.nofeshId).subscribe((result) =>{
  //     this.currentNumberOfRooms = result.data;
  //       debugger;
  //   })
  // }

  //should return a list of herkevHazmana
  // getCurrentHerkevHazmana()
  // {
  //   this._adminService.GetCurrentHerkevHazmana(this.nofesh.value.ms_zehut_mazmin,this.nofesh.value.nofeshTitle).subscribe((result) =>{
  //     debugger;
  //     this.CurrentHerkevHazmana = {
  //       nofesh_id: result.data.nofesh_id,
  //       ms_amit: result.data.ms_amit,
  //       ms_nilve: result.data.ms_nilve,
  //       ms_yeladim: result.data.ms_yeladim,
  //       ms_tinokot: result.data.ms_tinokot
  //   };
  //   })
  // }
  resetNofeshTitles()
  {
    this.nofeshTitles = [
      { key: 0, value: "בחר" }
    ];
    this.nofesh.value.nofeshTitle = 0;
  }
  resetNofeshTitlesAndTable()
  {
    this.nofshonimReservations = [];
    this.selectedReservation = undefined;
    this.nofeshTitles  = [
      { key: 0, value: "בחר" }
    ];
    this.nofesh.value.nofeshTitle = 0;
    
  }

  searchNofshonimhForNirshamim()
  {
 
    this.userMessages.clearAll();
    this.resetNofeshTitlesAndTable();
    
      this.validateOvedmsZehut(this.nofesh.value.ms_zehut_mazmin);
      if(this.ms_zehut_valid)
      {
        this.spinnerService.showSpinner();
        this._adminService.GetNofeshNofshonimAllNirshamimForOved(this.nofesh.value.ms_zehut_mazmin).subscribe((response: ResultOfOperation<IReservationChangeNofshon[]>) => {
          if(response.isSuccess)
          {
            this.spinnerService.hideSpinner();
              this.nofshonimReservations = response.data;
              this.nofesh.patchValue({nofesh_title: this.nofshonimReservations[0].nirshamim[0].nofesh_title});
              this.nofesh.patchValue({nofesh_from: this.nofshonimReservations[0].nirshamim[0].nofesh_from});
              this.nofesh.patchValue ({nofesh_to:this.nofshonimReservations[0].nirshamim[0].nofesh_to});

              //Object.assign(this.nofshonimReservationsFiltered, this.nofshonimReservation);
              // this.nofshonimReservations.forEach(reservation => {
              //   this.nofeshTitles.push({key: reservation.nirshamim[0].id_nofesh, value:reservation.nirshamim[0].nofesh_title});
              // });
              this.nofeshTitles = this._adminService.getNofeshTitles(this.nofshonimReservations);
              
          }
          else
          {
            this.spinnerService.hideSpinner();
            this.is_oved_searched = true;
          }
        })
      }
  }

  validateOvedmsZehut(ms_zehut)
  {
    let valid_zehut = this.validatemsZehut(ms_zehut);
    if (valid_zehut) {
        this.ms_zehut_valid = true;
    }
    else {
        this.ms_zehut_valid = false;
        this.nofesh.patchValue({ ms_zehut: "" });
        return;
    }
  }
  validatemsZehut(value) {

    if (value.length == 0)
        return false;


    var result = true;
    var first8 = null;
    var cifratBikoret = null;
    try {
        if (value.length == 10)
            first8 = value.substring(0, 9);
        else {
            if (value.length == 9)
                first8 = "0" + value.substring(0, 8);
            else
                first8 = "00" + value.substring(0, 8);
        }
        cifratBikoret = value.substring(value.length - 1);
        var checkDigits = 0 * 1;
        var temp = 0;
        var i = 0;

        for (i = 1; i <= 9; i++) {
            temp = first8.charAt(i - 1);
            checkDigits = temp * 1 + checkDigits * 1;
            if ((i % 2) == 1) {
                checkDigits = temp * 1 + checkDigits * 1;
                if (temp > 4)
                    checkDigits = checkDigits * 1 - 9;
            }
        }
        checkDigits = (10 - checkDigits % 10) % 10;
        result = (checkDigits * 1 == cifratBikoret * 1);
    }
    catch (e) { result = false; }
    if (value == "0")
        result = false;
    return result;
}
onMsZehutSearchChange(value:string){
  this.is_oved_searched = false; 
}
getAllNofshonim()
{
    this._nofeshService.getAllNofashim().subscribe(res =>{
      if(res.isSuccess)
      {
            let nofshonim = res.data;
          //get all nofshonim except the current one in reservatiuon.
           nofshonim = nofshonim.filter(nofshonim=>nofshonim.nofeshType == 4 && nofshonim.k_pail ==1 &&nofshonim.id_nofesh!=this.nofesh.value.nofeshTitle)
            this.allNofshonimTitles = this._adminService.getAllNofshonimTitles(nofshonim);           
      }
      else
      {
        this._userMessagesService.setErrorMessage("לא קיימים נופשונים - אנא פנה למנהל המערכת")
      }
    })

}
currentNofshonForChange()
{
 
  let selectedReservationForChange = this.allNofshonimTitles.find(reservation => reservation.key == this.nofesh.value.nofeshTitleForChange);
  this.nofeshId =  this.nofesh.value.nofeshTitleForChange;
  
}
}
